import { TextFieldModule } from '@angular/cdk/text-field';
import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { UntilDestroy } from '@ngneat/until-destroy';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
  DatepickerHeaderComponent,
  TiimeDatepickerModule,
  TiimeFormModule,
  TiimeIconModule,
  TiimeInputContainerModule,
  TiimeSelectModule,
  TiimeTooltipModule
} from 'tiime-material';

import { ProspectAcquisitionChannel } from '@gi/enums/prospect-acquisition-channel.enum';
import { TiimeBusinessProAccountIntention } from '@gi/enums/tiime-business-pro-account-intention.enum';
import { ProspectForm } from '@gi/forms/prospect-form';
import { BusinessUnit } from '@models/business-unit';
import { Civility } from '@models/civility';
import { CodeAndLabel } from '@models/code-and-label';
import { Partner } from '@models/partner';
import { TiimeBusinessProAccountIntentionIconComponent } from '@shared-components/tiime-business-pro-account-intention-icon/tiime-business-pro-account-intention-icon.component';
import { DigitOnlyDirective } from '@shared-directives/digit-only/digit-only.directive';
import { UppercaseInputDirective } from '@shared-directives/uppercase-input/uppercase-input.directive';
import { BusinessUnitSelectComponent } from '@shared-selectors/business-unit-select/business-unit-select.component';
import { CodeAndLabelSelectComponent } from '@shared-selectors/code-and-label-select/code-and-label-select.component';
import { ContributorSelectComponent } from '@shared-selectors/contributor-select/contributor-select.component';
import { LegalFormSelectComponent } from '@shared-selectors/legal-form-select/legal-form-select.component';
import { TiimeBusinessProAccountIntentionSelectComponent } from '@shared-selectors/tiime-business-pro-account-intention-select/tiime-business-pro-account-intention-select.component';
import { UserCivilitySelectComponent } from '@shared-selectors/user-civility-select/user-civility-select.component';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-prospect-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TextFieldModule,
    TiimeInputContainerModule,
    TiimeFormModule,
    TiimeIconModule,
    TiimeDatepickerModule,
    ContributorSelectComponent,
    UserCivilitySelectComponent,
    LegalFormSelectComponent,
    BusinessUnitSelectComponent,
    TiimeSelectModule,
    CodeAndLabelSelectComponent,
    UppercaseInputDirective,
    TiimeBusinessProAccountIntentionIconComponent,
    TiimeBusinessProAccountIntentionSelectComponent,
    TiimeTooltipModule,
    DigitOnlyDirective
  ],
  templateUrl: './prospect-form.component.html',
  styleUrls: ['./prospect-form.component.scss']
})
export class ProspectFormComponent implements OnInit, AfterViewInit {
  @Input({ required: true }) prospectForm: ProspectForm;
  @Input({ required: true }) civilities: Civility[];
  @Input({ required: true }) legalForms: string[];
  @Input({ required: true }) partner: Partner;
  @Input({ required: true }) businessUnits: BusinessUnit[];
  @Input({ required: true }) acquisitionChannels: CodeAndLabel<ProspectAcquisitionChannel>[];
  @Input({ required: true }) tiimeBusinessProAccountIntentions: CodeAndLabel<TiimeBusinessProAccountIntention>[];

  @ViewChild('firstNameInput') firstNameInput: ElementRef<HTMLInputElement>;

  readonly tiimeDatepickerHeader = DatepickerHeaderComponent;

  private readonly subscription = new Subscription();

  ngOnInit(): void {
    this.observeAppointmentDate();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.firstNameInput?.nativeElement.focus());
  }

  private observeAppointmentDate(): void {
    this.subscription.add(
      this.prospectForm.appointmentDate.valueChanges
        .pipe(
          tap(appointmentDate => {
            if (!appointmentDate) {
              this.prospectForm.appointmentTime.reset();
            }
          })
        )
        .subscribe()
    );
  }
}
